export const SEGMENTED_CONTROL_OPTION_PREFIX = 'segmented-control-option-';
export const SEGMENTED_CONTROL_TEST_ID = 'segmented-control';
